<template>
  <div class="select-map-pos-container">
    <!-- 搜索和定位控制栏 -->
    <div class="map-toolbar">
      <div class="search-box">
        <el-input
          v-model="searchKeyword"
          placeholder="搜索地点"
          class="search-input"
          clearable
          @clear="clearSearch"
          @keyup.enter.native="searchLocation"
        >
          <i slot="prefix" class="el-input__icon el-icon-search"></i>
        </el-input>
        <el-button type="primary" icon="el-icon-search" size="small" @click="searchLocation">搜索</el-button>
      </div>
      <el-button type="primary" plain icon="el-icon-location" size="small" @click="locateCurrentPosition" class="locate-btn">
        定位
      </el-button>
    </div>

    <!-- 搜索结果下拉列表 -->
    <div v-if="searchResults.length > 0" class="search-results" @click.stop>
      <div
        v-for="(result, index) in searchResults"
        :key="index"
        class="search-result-item"
        @click.stop="goToSearchResult(result)"
      >
        <div class="result-title">{{ result.title }}</div>
        <div class="result-address">{{ result.address }}</div>
      </div>
    </div>

    <!-- 地图容器 -->
    <div id="selectMap" style="width: 100%; height: 100%;"></div>
  </div>
</template>

<script>
import { getCommunityId } from '@/api/community/communityApi'

export default {
  name: 'SelectMapPos',
  props: {
    elementId: {
      type: String,
      default: 'selectMap'
    },
    initData: {
      type: Object,
      default: () => ({})
    }
  },

  data() {
    return {
      map: null,
      marker: null,
      communityId: '',
      mapData: {
        lat: 0,
        lng: 0
      },
      mapKey: '',
      searchKeyword: '',
      searchResults: [],
      currentLocationMarker: null
    }
  },
  mounted() {
    this.communityId = getCommunityId()
  },
  methods: {
    // 等待腾讯地图SDK加载并设置key
    waitForMapSDK() {
      return new Promise((resolve) => {
        // 如果TMap已经加载完成且有key
        if (window.TMap && window.TMap.key) {
          this.mapKey = window.TMap.key
          console.log('[地图SDK] 已加载，密钥:', this.mapKey.substring(0, 4) + '****')
          resolve()
          return
        }

        // TMap存在但key为空，手动设置key
        if (window.TMap) {
          window.TMap.key = 'VCPBZ-T4JYU-U6DVD-GN6XF-2WBLH-BQFT7'
          this.mapKey = window.TMap.key
          console.log('[地图SDK] 手动设置密钥:', this.mapKey.substring(0, 4) + '****')
          resolve()
          return
        }

        // 动态加载SDK
        console.log('[地图SDK] 动态加载腾讯地图SDK')
        const script = document.createElement('script')
        script.src = 'https://map.qq.com/api/gljs?v=1.exp&key=VCPBZ-T4JYU-U6DVD-GN6XF-2WBLH-BQFT7'
        script.onload = () => {
          if (window.TMap) {
            window.TMap.key = 'VCPBZ-T4JYU-U6DVD-GN6XF-2WBLH-BQFT7'
            this.mapKey = window.TMap.key
            console.log('[地图SDK] 加载成功，密钥:', this.mapKey.substring(0, 4) + '****')
          }
          resolve()
        }
        script.onerror = (e) => {
          console.error('[地图SDK] SDK加载失败', e)
          resolve()
        }
        document.head.appendChild(script)
      })
    },

    initMap(_data) {
      // 等待SDK加载完成
      this.waitForMapSDK().then(() => {
        this.initMapCore(_data)
      })
    },

    initMapCore(_data) {
      // 清除现有地图
      let _lng = 116.397128;
      let _lat = 39.916527;

      if (_data && _data.lng) {
        _lng = _data.lng;
      }

      if (_data && _data.lat) {
        _lat = _data.lat;
      }

      try {
        if (this.map) {
          this.map.destroy();
        }
      } catch (e) {
        console.log(e)
      }

      let addMap = new window.TMap.Map('selectMap', {
        center: new window.TMap.LatLng(_lat, _lng),
        zoom: 13
      });

      let _this = this

      // 添加点击监听事件
      addMap.on('click', function (event) {
        console.log('[地图点击] 经度:', event.latLng.lng, '纬度:', event.latLng.lat)
        _this.updateMarker(event.latLng)
        _this.$emit('position-change', {
          lat: event.latLng.lat,
          lng: event.latLng.lng
        })
      });

      this.map = addMap;
    },

    updateMarker(latLng) {
      // 清除现有标记
      if (this.marker) {
        this.marker.setMap(null)
      }

      // 创建新标记
      this.marker = new window.TMap.MultiMarker({
        map: this.map,
        styles: {
          "marker": new window.TMap.MarkerStyle({
            width: 25,
            height: 35,
            src: '/img/maper.png',
            anchor: { x: 32, y: 32 }
          })
        },
        geometries: [{
          id: '1',
          styleId: 'marker',
          position: latLng
        }]
      })
    },

    addMarker(position) {
      this.updateMarker(position)
      // 移动地图中心到标记位置
      this.map.setCenter(position)
      this.map.setZoom(16)
    },

    updatePosition(lat, lng) {
      if (!this.map) return

      const position = new window.TMap.LatLng(lat, lng)
      this.addMarker(position)
    },

    // 搜索位置 - 使用腾讯地图WebService API
    searchLocation() {
      console.log('[位置搜索] 开始搜索，关键词:', this.searchKeyword)

      if (!this.searchKeyword || !this.searchKeyword.trim()) {
        console.warn('[位置搜索] 搜索关键词为空')
        this.$message.warning('请输入搜索关键词')
        return
      }

      // 确保key已设置
      if (!this.mapKey) {
        if (window.TMap && window.TMap.key) {
          this.mapKey = window.TMap.key
        } else if (window.TMap) {
          window.TMap.key = 'VCPBZ-T4JYU-U6DVD-GN6XF-2WBLH-BQFT7'
          this.mapKey = window.TMap.key
        } else {
          this.$message.warning('地图加载中，请稍后再试')
          return
        }
      }

      var _this = this
      var keyword = encodeURIComponent(this.searchKeyword.trim())
      console.log('[位置搜索] 编码后的关键词:', keyword)

      // 使用JSONP方式调用腾讯地图WebService搜索接口
      var url = 'https://apis.map.qq.com/ws/place/v1/search?keyword=' + keyword + '&boundary=region(全国,0)&key=' + this.mapKey + '&output=jsonp&callback=JSONP_CALLBACK'
      console.log('[位置搜索] 请求URL:', url.replace(this.mapKey, this.mapKey.substring(0, 4) + '****'))

      // 创建JSONP请求
      var script = document.createElement('script')
      script.src = url
      console.log('[位置搜索] 创建JSONP请求')

      // 设置JSONP回调函数
      window.JSONP_CALLBACK = function(response) {
        console.log('[位置搜索] 收到响应，状态码:', response.status, '数据条数:', response.data ? response.data.length : 0)
        delete window.JSONP_CALLBACK
        if (script.parentNode) {
          document.body.removeChild(script)
        }

        if (response.status === 0 && response.data && response.data.length > 0) {
          console.log('[位置搜索] 搜索成功，结果:', JSON.stringify(response.data.slice(0, 3)))
          _this.searchResults = response.data.slice(0, 10)
          _this.$message.success('找到 ' + _this.searchResults.length + ' 个结果')
        } else {
          console.warn('[位置搜索] 搜索失败，状态:', response.status, '信息:', response.message)
          _this.searchResults = []
          _this.$message.info('未找到相关位置')
        }
      }

      // 超时处理
      setTimeout(function() {
        if (window.JSONP_CALLBACK) {
          console.warn('[位置搜索] 请求超时')
          delete window.JSONP_CALLBACK
          if (script.parentNode) {
            document.body.removeChild(script)
          }
          _this.$message.error('搜索超时，请重试')
        }
      }, 10000)

      script.onerror = function(e) {
        console.error('[位置搜索] 网络请求失败', e)
        delete window.JSONP_CALLBACK
        if (script.parentNode) {
          document.body.removeChild(script)
        }
        _this.$message.error('搜索失败，请检查网络连接')
      }

      document.body.appendChild(script)
      console.log('[位置搜索] JSONP脚本已添加到DOM，等待响应...')
    },

    // 点击搜索结果，定位到该位置
    goToSearchResult(result) {
      console.log('[搜索结果] 点击搜索结果:', JSON.stringify(result))

      // 腾讯地图WebService返回的location格式
      var lat = result.location && result.location.lat
      var lng = result.location && result.location.lng
      console.log('[搜索结果] 解析坐标，纬度:', lat, '经度:', lng)

      if (!lat || !lng) {
        console.warn('[搜索结果] 无法获取有效坐标')
        this.$message.warning('无法获取该位置的坐标信息')
        this.searchResults = []
        return
      }

      // 如果地图未初始化，先初始化
      if (!this.map) {
        console.log('[搜索结果] 地图未初始化，使用坐标初始化地图')
        this.waitForMapSDK().then(() => {
          this.initMapWithPosition(lat, lng)
        })
      } else {
        this.moveToPosition(lat, lng)
      }

      // 清除搜索结果列表
      this.searchResults = []
    },

    // 使用指定坐标初始化地图
    initMapWithPosition(lat, lng) {
      console.log('[地图初始化] 使用坐标初始化，纬度:', lat, '经度:', lng)

      try {
        if (this.map) {
          this.map.destroy()
        }
      } catch (e) {
        console.log(e)
      }

      let addMap = new window.TMap.Map('selectMap', {
        center: new window.TMap.LatLng(lat, lng),
        zoom: 16
      })

      let _this = this

      // 添加点击监听事件
      addMap.on('click', function (event) {
        console.log('[地图点击] 经度:', event.latLng.lng, '纬度:', event.latLng.lat)
        _this.updateMarker(event.latLng)
        _this.$emit('position-change', {
          lat: event.latLng.lat,
          lng: event.latLng.lng
        })
      })

      // 添加标记
      let position = new window.TMap.LatLng(lat, lng)
      this.updateMarkerOnMap(addMap, position)

      this.map = addMap
    },

    // 在指定地图上更新标记
    updateMarkerOnMap(map, position) {
      if (this.marker) {
        this.marker.setMap(null)
      }

      this.marker = new window.TMap.MultiMarker({
        map: map,
        styles: {
          "marker": new window.TMap.MarkerStyle({
            width: 25,
            height: 35,
            src: '/img/maper.png',
            anchor: { x: 32, y: 32 }
          })
        },
        geometries: [{
          id: '1',
          styleId: 'marker',
          position: position
        }]
      })
    },

    // 移动地图到指定位置
    moveToPosition(lat, lng) {
      console.log('[移动地图] 移动到纬度:', lat, '经度:', lng)

      var position = new window.TMap.LatLng(lat, lng)

      // 更新标记
      this.updateMarker(position)

      // 移动地图中心到搜索位置
      this.map.setCenter(position)
      this.map.setZoom(16)

      // 触发位置变化事件
      this.$emit('position-change', {
        lat: lat,
        lng: lng
      })

      console.log('[移动地图] 定位完成')
    },

    // 清除搜索
    clearSearch() {
      this.searchResults = []
      this.searchKeyword = ''
    },

    // 定位到当前位置
    locateCurrentPosition() {
      console.log('[GPS定位] 开始获取当前位置')

      if (!this.map) {
        console.warn('[GPS定位] 地图未初始化')
        this.$message.warning('地图尚未初始化')
        return
      }

      // 使用浏览器原生定位
      if (navigator.geolocation) {
        console.log('[GPS定位] 浏览器支持地理定位，开始请求位置')
        navigator.geolocation.getCurrentPosition(
          (position) => {
            var lat = position.coords.latitude
            var lng = position.coords.longitude
            var accuracy = position.coords.accuracy
            console.log('[GPS定位] 获取位置成功，纬度:', lat, '经度:', lng, '精度:', accuracy, '米')
            this.showCurrentLocation(lat, lng)
          },
          (error) => {
            console.error('[GPS定位] 获取位置失败，错误码:', error.code, '错误信息:', error.message)
            var errorMsg = '定位失败，请检查浏览器定位权限设置'
            if (error.code === 1) {
              errorMsg = '定位失败，请允许浏览器获取位置权限'
            } else if (error.code === 2) {
              errorMsg = '定位失败，无法获取位置信息'
            } else if (error.code === 3) {
              errorMsg = '定位超时，请重试'
            }
            this.$message.error(errorMsg)
          },
          {
            enableHighAccuracy: true,
            timeout: 10000,
            maximumAge: 60000
          }
        )
      } else {
        console.error('[GPS定位] 当前浏览器不支持地理定位')
        this.$message.error('当前浏览器不支持地理定位')
      }
    },

    // 在地图上显示当前位置
    showCurrentLocation(lat, lng) {
      console.log('[显示位置] 开始在地图上显示位置，纬度:', lat, '经度:', lng)

      var position = new window.TMap.LatLng(lat, lng)

      // 清除之前的定位标记
      if (this.currentLocationMarker) {
        console.log('[显示位置] 清除之前的定位标记')
        this.currentLocationMarker.setMap(null)
      }

      // 创建当前位置标记
      console.log('[显示位置] 创建定位标记')
      this.currentLocationMarker = new window.TMap.MultiMarker({
        map: this.map,
        styles: {
          'currentLocation': new window.TMap.MarkerStyle({
            'width': 30,
            'height': 30,
            'src': 'https://mapapi.qq.com/web/jsapi/demo/img/center.gif',
            'anchor': { x: 15, y: 15 }
          })
        },
        geometries: [{
          id: 'current_location',
          styleId: 'currentLocation',
          position: position
        }]
      })

      // 地图中心点移到当前位置
      console.log('[显示位置] 移动地图中心点，设置缩放级别为16')
      this.map.setCenter(position)
      this.map.setZoom(16)

      // 同时更新常规标记和触发位置变化
      this.updateMarker(position)
      this.$emit('position-change', {
        lat: lat,
        lng: lng
      })

      this.$message.success('已定位到当前位置')
    }
  },
  beforeDestroy() {
    // 组件销毁时清除地图实例
    if (this.map) {
      this.map.destroy()
      this.map = null
    }
  }
}
</script>

<style scoped>
.select-map-pos-container {
  width: 100%;
  height: 100%;
  position: relative;
}

.map-toolbar {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 8px;
  background: #fff;
  border-bottom: 1px solid #e8e8e8;
  position: relative;
  z-index: 100;
}

.search-box {
  display: flex;
  align-items: center;
  flex: 1;
}

.search-input {
  width: 200px;
  margin-right: 8px;
}

.locate-btn {
  white-space: nowrap;
}

.search-results {
  position: absolute;
  top: 50px;
  left: 8px;
  width: 300px;
  max-height: 200px;
  overflow-y: auto;
  background: #fff;
  border: 1px solid #e8e8e8;
  border-radius: 4px;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.1);
  z-index: 2000;
}

.search-result-item {
  padding: 8px 12px;
  cursor: pointer;
  border-bottom: 1px solid #f0f0f0;
  transition: background-color 0.2s;
  touch-action: manipulation;
}

.search-result-item:last-child {
  border-bottom: none;
}

.search-result-item:hover {
  background-color: #f5f5f5;
}

.result-title {
  font-size: 13px;
  font-weight: 500;
  color: #333;
  margin-bottom: 2px;
}

.result-address {
  font-size: 11px;
  color: #999;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
</style>
